import * as React from "react"
import { Form, Col } from "react-bootstrap"
import DatePicker from "react-datepicker"
import { BirthdayInput } from "../FormattedInputs/BirthdayInput"

interface FromToDatesProps {
  from?: Date
  to?: Date
  minDate?: Date
  disabled?: boolean
  onChangeFrom: (date: Date) => void
  onChangeTo: (date: Date) => void
}

interface FromToDatesState {
  from?: Date
  to?: Date
}

export default class FromToDates extends React.PureComponent<FromToDatesProps, FromToDatesState> {
  state: FromToDatesState = { }

  onFromSelect = (date: Date) => this.props.onChangeFrom(date)
  onToSelect = (date: Date) => this.props.onChangeTo(date)

  componentDidUpdate(prevProps: FromToDatesProps) {
    if (prevProps.from !== this.props.from || prevProps.to !== this.props.to) {
      this.setState({ from: this.props.from, to: this.props.to })
    }
  }

  render() {
    const { from, to } = this.state
    const { disabled } = this.props

    return (<Form>
      <Form.Row className="form-group">
        <Form.Label column lg={2} htmlFor="from" className={disabled ? "" : "required"}>From</Form.Label>
          <Col lg={6}>
            <DatePicker id="from"
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              enableTabLoop={false}
              selected={from}
              disabled={disabled}
              minDate={this.props.minDate}
              maxDate={to || new Date()}
              onChange={date => this.onFromSelect(date as Date)}
              customInput={<BirthdayInput />}
            />
          </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column lg={2} htmlFor="to" className={disabled ? "" : "required"}>To</Form.Label>
        <Col lg={6}>
          <DatePicker id="to"
            className="form-control"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            enableTabLoop={false}
            selected={to}
            disabled={disabled}
            minDate={from}
            maxDate={new Date()}
            onChange={date => this.onToSelect(date as Date)}
            customInput={<BirthdayInput />}
          />
        </Col>
      </Form.Row>
    </Form>)
  }
}